document.addEventListener("DOMContentLoaded", function () {
  let currentPage = 1;
  const limit = 24;

  // Cache elements
  const grid = document.getElementById("property-grid");
  const count = document.getElementById("property-count");
  const pageInfo = document.getElementById("page-info");
  const prevBtn = document.getElementById("prev-page");
  const nextBtn = document.getElementById("next-page");
  const applyFiltersBtn = document.getElementById("apply-filters");
  const clearFiltersBtn = document.getElementById("clear-filters");
  const searchInput = document.getElementById("filter-search");
  const sortSelect = document.getElementById("sort-properties");

  async function loadProperties(page = 1) {
    grid.innerHTML = '<div class="loading">Loading properties...</div>';

    try {
      const filters = PropertyFilters.getValues();
      const result = await PropertyAPI.getProperties({ page, limit, ...filters });

      if (!result.success || !result.data || result.data.length === 0) {
        grid.innerHTML = `
          <div class="no-results">
            <h3>No properties found</h3>
            <p>Try changing your filters.</p>
          </div>
        `;
        return;
      }

      // Batch rendering for performance
      const htmlFragment = result.data.map(createPropertyCard).join('');
      grid.innerHTML = htmlFragment;

      // Update UI
      count.textContent = `${Number(result.total).toLocaleString()} properties found`;
      pageInfo.textContent = `Page ${result.page} of ${result.total_pages}`;
      currentPage = Number(result.page);

      prevBtn.disabled = currentPage <= 1;
      nextBtn.disabled = currentPage >= Number(result.total_pages);
    } catch (error) {
      console.error("Property load error:", error);
      grid.innerHTML = `
        <div class="api-error">
          <p>Unable to load properties. Please try again later.</p>
        </div>
      `;
    }
  }

  // Use helper functions to keep the main logic clean
  function createPropertyCard(property) {
  const auctionDate =
    property.SaleDate ||
    property.Sale_Date ||
    property.AuctionDate ||
    property.auction_date ||
    property.sale_date;

  return `
    <div class="property-card" data-case="${property.CaseNumber}">
      <div class="property-image-wrap">
        <img
          class="property-card-image"
          src="${property.StreetViewURL}"
          alt="${property.Address}"
          loading="lazy"
          onerror="this.src='https://placehold.co/600x300?text=Unavailable';"
        >

        <button
          class="wishlist-floating ${
            PropertyWishlist.isSaved(property.CaseNumber) ? "saved" : ""
          }"
          data-case="${property.CaseNumber}"
          aria-label="Save property"
        >
          ${PropertyWishlist.isSaved(property.CaseNumber) ? "♥" : "♡"}
        </button>
      </div>

      <div class="property-body">
        <span class="status-badge ${PropertyUtils.getStatusClass(property.CurrentStatus)}">
          ${PropertyUtils.getStatusLabel(property.CurrentStatus)}
        </span>

        <p class="property-price">
          ${PropertyUtils.formatMoney(property.County_Market_Value)}
        </p>

        <h3 class="property-address">
          ${property.Address}
        </h3>

        <p class="property-location">
          ${property.City}, FL ${property.Zip}
        </p>

        <div class="property-specs-row">
          <span>🛏 ${property.Property_Beds || "N/A"}</span>
          <span>🛁 ${property.Property_Baths || "N/A"}</span>
          <span>📐 ${property.Property_Lot_Size || "N/A"} lot</span>
        </div>

        <div class="property-card__footer">
          <div class="auction-info">
            <span class="auction-info__icon" aria-hidden="true">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="3"
                  y="5"
                  width="18"
                  height="16"
                  rx="2"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <path
                  d="M8 3V7M16 3V7M3 10H21"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M8 14H10M14 14H16M8 18H10"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </span>

            <span class="auction-info__content">
              <span class="auction-label">Auction Date</span>
              <span class="auction-date">
                ${formatAuctionDate(auctionDate)}
              </span>
            </span>
          </div>

          <button
            type="button"
            class="details-btn"
            data-case="${property.CaseNumber}"
          >
            <span>View Details</span>

          </button>
        </div>
      </div>
    </div>
  `;
}

function formatAuctionDate(value) {
  if (!value) return "Date pending";

  const normalizedValue =
    /^\d{4}-\d{2}-\d{2}$/.test(value)
      ? `${value}T12:00:00`
      : value;

  const date = new Date(normalizedValue);

  if (Number.isNaN(date.getTime())) {
    return "Date pending";
  }

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
}

  // Event Listeners (Event Delegation)
  grid.addEventListener("click", async (event) => {
    const wishlistBtn = event.target.closest(".wishlist-floating");
    if (wishlistBtn) {
      const caseNumber = wishlistBtn.dataset.case;
      const isSaved = await PropertyWishlist.toggle(caseNumber);
      wishlistBtn.classList.toggle("saved", isSaved);
      wishlistBtn.textContent = isSaved ? "♥" : "♡";
      return;
    }

    const detailsBtn = event.target.closest(".details-btn");
    if (detailsBtn) {
      window.location.href = `/pages/property-details?case_number=${encodeURIComponent(detailsBtn.dataset.case)}`;
    }
  });

  prevBtn.addEventListener("click", () => currentPage > 1 && loadProperties(currentPage - 1));
  nextBtn.addEventListener("click", () => loadProperties(currentPage + 1));
  applyFiltersBtn.addEventListener("click", () => {
  loadProperties(1);
  });

  clearFiltersBtn.addEventListener("click", () => {
    PropertyFilters.clear();
    loadProperties(1);
  });

  searchInput?.addEventListener("keydown", (event) => {
    if (event.key !== "Enter") {
      return;
    }

    event.preventDefault();
    loadProperties(1);
  });

  sortSelect?.addEventListener("change", () => {
    loadProperties(1);
  });

    // Initial load
    PropertyFilters.init();
    loadProperties();
  });